import styled, { css } from 'styled-components';
import { color, font, query, space } from '@design/templateFns';
import { InputGroup } from '@components/FormFields/';
import { MapWrapper } from '@components/GoogleMapResults/styles';
import {
  // imported for the 50/50 view
  ContactDetailList,
} from '@components/Card/PropertyListingCard/style';
import { StyledCardContainer } from '@components/CardGridWithPagination';
import { CardContentDetailListStyled } from '@components/Card/style';
export const SearchPropertiesWrapper = styled.div<{ $viewBy: string }>`
  ${({ $viewBy }) =>
    $viewBy === '50/50' && // these are special for the 50/50 view
    css`
      @media screen and (${query.atLeast('desktop')}) {
        display: flex;
        flex-wrap: nowrap;
      }

      ${StyledCardContainer} {
        grid-template-columns: 100%;

        @media only screen and (${query.atLeast('max')}) {
          grid-template-columns: repeat(2, 1fr);
        }
      }

      ${CardContentDetailListStyled} {
        font-size: 14px;
      }
      ${ContactDetailList} {
        li + li {
          margin-left: ${space('xs')};

          &:before {
            margin-right: ${space('xs')};
          }
        }
      }

      ${PropertyListWrapper} {
        @media screen and (${query.atLeast('desktop')}) {
          flex: 0 0 50%;
          width: 50%;
          padding-right: ${space('x5')};
          box-sizing: border-box;
        }
      }

      ${MapSection} {
        @media screen and (${query.below('desktop')}) {
          display: none;
        }

        @media screen and (${query.atLeast('desktop')}) {
          width: 50%;
          flex: 0 0 50%;
          margin-top: -1px;
          position: relative;

          > div {
            position: sticky;
            top: 0;
          }
        }
      }
    `}
`;
export const PropertyListWrapper = styled.div``;

export const PropertyActions = styled.div`
  width: 100%;
  .properties-search__market-details--wrapper.mobile {
    display: block;
    @media screen and (${query.atLeast('tablet')}) {
      display: none;
    }
  }
`;
export const PropertyListWrapperInner = styled.div<{ $viewBy: string }>`
  .properties-search__market-details--wrapper.desktop {
    display: none;
  }
  @media screen and (${query.atLeast('tablet')}) {
    display: flex;
    ${({ $viewBy }) =>
      $viewBy !== '50/50' && // these are special for the 50/50 view
      css`
        align-items: flex-end;
      `}
    .properties-search__market-details--wrapper {
      padding-top: ${space('x6')};
      padding-bottom: ${space('x6')};
      line-height: 1;
      margin-left: auto;
      &.desktop {
        display: block;
      }
    }
  }
`;

export const SavedPropertyListWrapper = styled.div`
  @media screen and (${query.atLeast('desktop')}) {
    padding-right: ${space('marginMobile')};
  }

  @media screen and (${query.atLeast('max')}) {
    padding-right: ${space('marginMobile')};
  }
`;
export const PropertyWrapper = styled.div``;

export const DropdownFilterWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 24px;
`;

export const PropertiesSubheaderContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding-bottom: ${space('x6')};
  flex-direction: column-reverse;
  gap: ${space('xs')};
`;
export const PropertiesSubheaderContainerCol = styled.div`
  display: flex;
  flex-wrap: wrap;
  row-gap: ${space('xs')};
  // column-gap added here for when viewBy is 50/50
  column-gap: ${space('x10')};
  justify-content: space-between;
  div:first-child {
    @media screen and (${query.below('desktop')}) {
      flex: 0 0 100%;
      width: 100%;
    }
  }
  @media screen and (${query.below('tablet')}) {
    padding-top: ${space('xs')};
    gap: 3px;
    justify-content: space-between;
  }
`;
export const SearchMain = styled.div`
  max-width: 1272px;
  margin: 0 auto;
  padding-top: calc(${space('x8')} - ${space('xl')});
  padding-bottom: 0;
  position: sticky;
  top: 0;
  background-color: ${color('bg')};
  z-index: 99;
  @media screen and (${query.below('tablet')}) {
    padding: 0;
    width: 100%;
    max-width: 100%;
  }
`;
export const SearchbarWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 20px;
  padding-bottom: calc(${space('x8')} - ${space('xl')});
  margin-bottom: ${space('x6')};
  border-bottom: 1px solid ${color('gray2')};
  z-index: 99;
  @media screen and (${query.atLeast('desktop')}) {
    flex-direction: row;
  }
  @media screen and (${query.below('tablet')}) {
    left: 0;
    width: 100%;
    height: 100%;
    padding: 20px;
    box-sizing: border-box;
    margin-bottom: 0px;
  }
  @media only screen and (${query.atLeast('tablet')}) and (max-width: 1280px) {
    flex-direction: column;
  }
`;

export const SearchInput = styled.input<{ $active?: boolean }>`
  z-index: 10;
  background-color: ${({ $active }) =>
    $active ? `${color('gray1')()} !important` : 'transparent'};
  border-color: ${({ $active }) => ($active ? `${color('gray1')()} !important` : color('gray2'))};
  &:focus {
    border-color: #d4d4d4;
    box-shadow: 0 0 0 0px #d4d4d4 !important;
  }
`;

export const SearchInputWrapper = styled(InputGroup)`
  width: 100%;
  position: relative;
  @media screen and (${query.atLeast('desktop')}) {
    flex: 0 1 335px;
    max-width: 335px;
  }
  @media only screen and (${query.atLeast('tablet')}) and (max-width: 1280px) {
    width: 100%;
    max-width: 100%;
    flex: 0 1 auto;
  }
`;

export const SearchButton = styled.button``;

export const Main = styled.main`
  min-height: 100vh;
`;

export const AutocompleteWrapper = styled.div`
  position: absolute;
  background: #fff;
  box-sizing: border-box;
  top: calc(100% - 1px);
  z-index: 1;
  width: 100%;
  background-color: ${color('bg')};
  border-radius: 0 0 4px 4px;
  box-shadow: 2px 4px 15px rgba(0, 0, 0, 0.1);

  li {
    list-style-type: none;
  }
`;

export const AutocompleteSection = styled.ul<{
  $noBorder?: boolean;
  $header?: string;
}>`
  padding: 0;
  margin: 0;
  border-top: ${({ $noBorder }) => (!$noBorder ? '1px solid #d4d4d4' : 'none')};
  color: #242323;
  position: relative;
  ${font('body-md-light')}
  ${({ $header }) =>
    $header &&
    css`
      padding-top: ${space('lg')};
      margin-top: ${space('lg')};
      &:before {
        content: '${$header}';
        background: #fff;
        padding: 0 ${space('md')};
        position: absolute;
        top: -12px;
        left: 0;
        color: #757575;
      }
    `}
`;

export const AutocompleteItem = styled.li`
  border: none;
  cursor: pointer;
  padding: ${space('sm')} ${space('md')};
  display: flex;
  align-items: center;
  gap: ${space('sm')};
  &:hover {
    background-color: #f4f4f4;
  }
`;
export const AutocompleteItemIcon = styled.span`
  width: 20px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const AutocompleteItemText = styled.span`
  flex-grow: 1;
`;

export const PropertiesContainer = styled.div`
  margin-top: ${space('x6')};
  @media (${query.below('tablet')}) {
    margin-top: 0;
  }
`;
export const MapSection = styled.section`
  .gm-bundled-control-on-bottom {
    top: 30px;
  }
`;
export const Headline = styled.h1`
  ${font('headline-sm')};
  text-align: left;
  padding-top: ${space('x6')};
  padding-bottom: ${space('sm')};
  @media (${query.below('tablet')}) {
    ${font('headline-xxs')};
  }
`;
export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${space('x7')};
  padding-bottom: ${space('x7')};
  @media (${query.atLeast('desktop')}) {
    margin-top: ${space('x8')};
    padding-bottom: ${space('x14')};
  }
`;

export const SkeletonMapContainer = styled(MapWrapper)`
  background-color: ${color('gray1')};
  height: 100%;
`;

export const OverWriteSelect = styled.div`
  div:nth-child(2) {
    @media screen and (${query.below('tablet')}) {
      position: fixed;
      bottom: 0;
      top: inherit;
      max-width: inherit;
      min-width: inherit;

      ul {
        position: initial;

        li {
          text-align: center;
          max-width: inherit;
          justify-content: center;
        }
      }
    }
  }
`;

export const CurrentLoc = styled.div`
  position: absolute;
  padding: 1px 14px;
  background-color: rgba(230, 230, 230, 0.85);
  font-size: 12px;
  border-radius: 4px;
  transform: translateY(calc(-100% - 4px));
  user-select: none;
  cursor: pointer;
  font-weight: bold;
  transition: 0.2s;
  &:hover {
    background-color: rgba(230, 230, 230, 1);
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  overflow: visible;
  justify-content: space-between;
  @media only screen and (${query.atLeast('tablet')}) and (max-width: 1280px) {
    justify-content: flex-start;
  }
`;
